import Result from "@/core/common/Result";
import { IBase64Converter } from "../ports/Base64Convert";
import { injectable } from "inversify";
import "reflect-metadata";

@injectable()
export class Base64ConvertAdapter implements IBase64Converter {
  async convert(file: File | undefined | null): Promise<Result<string>> {
    try {
      const arquivo = await new Promise<string>((resolve, reject) => {
        if (!file) return undefined;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          const file = reader.result?.toString();

          if (file === undefined)
            throw new Error("Erro ao converter o arquivo");

          return resolve(file);
        };
        reader.onerror = (error) => reject(error);
      });

      return Result.ok(arquivo);
    } catch (_e) {
      return Result.fail("Erro ao converter o arquivo");
    }
  }
}
